const API_BASE_URL =
  "https://usefullsofware.com/visioner7_api_services/v1/dxn/";

export const productoService = {
  async obtenerProductos() {
    try {
      // 1. Obtener el token del localStorage
      const token = localStorage.getItem("auth_token");

      if (!token) {
        return {
          success: false,
          error: "No hay sesión activa. Por favor, inicie sesión nuevamente.",
          code: 401,
        };
      }

      // 2. Realizar la petición al servidor
      const response = await fetch(`${API_BASE_URL}productos/listar.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          token: token,
        }),
      });

      // 3. Manejar errores de red o HTTP (401, 403, 500)
      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          return {
            success: false,
            error: "Sesión expirada o permisos insuficientes.",
            code: response.status,
          };
        }
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();

      // 4. Validar la estructura de respuesta del servidor PHP
      if (data.server_mensaje && data.server_mensaje.ESTADO === 1) {
        return {
          success: true,
          data: data.data || [],
          mensaje: data.server_mensaje.MENSAJE,
        };
      } else {
        return {
          success: false,
          error:
            data.server_mensaje?.MENSAJE || "Error al obtener los productos.",
          code: 400,
        };
      }
    } catch (error) {
      console.error("Error en productoService.obtenerProductos:", error);
      return {
        success: false,
        error: "Error de conexión con el servidor. Intente nuevamente.",
        code: 500,
      };
    }
  },

  async editarProducto(id_producto, datosActualizados) {
    try {
      const token = localStorage.getItem("auth_token");

      if (!token) {
        return { success: false, error: "No hay sesión activa.", code: 401 };
      }

      // El payload debe incluir el token, el id y solo los campos que se van a actualizar
      const payload = {
        token: token,
        id_producto: parseInt(id_producto),
        ...datosActualizados,
      };

      // Asumimos que tu archivo PHP se llama editar.php (ajusta la URL si es diferente)
      const response = await fetch(`${API_BASE_URL}productos/editar.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          return {
            success: false,
            error: "Sesión expirada o no tienes permisos de administrador.",
            code: response.status,
          };
        }
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();

      if (data.server_mensaje && data.server_mensaje.ESTADO === 1) {
        return { success: true, mensaje: data.server_mensaje.MENSAJE };
      } else {
        return {
          success: false,
          error:
            data.server_mensaje?.MENSAJE || "Error al actualizar el producto.",
        };
      }
    } catch (error) {
      console.error("Error en productoService.editarProducto:", error);
      return {
        success: false,
        error: "Error de conexión al guardar los cambios.",
      };
    }
  },
};
